import { Component } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ICustomerPhotos } from '../../interfaces/customer-photos';
import { IPhotoAreaGridItem, PhotoArea } from '../../interfaces/photo-area';
import { CustomerService } from '../../services';
import { PhotoAreaService } from '../../services';
import { TaskService } from '../../services';
import { UserService } from '../../services';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { StepType } from '../job-control/step.type';

@Component({
  templateUrl: './customer-photos-details.component.html',
})
export class CustomerPhotosDetailsComponent {
  stepTypesOpts: SelectItem[] = [];
  selectedStepTypes: StepType[] = [];
  isVme: boolean;

  photoAreas: IPhotoAreaGridItem[] = [];

  private _customer: ICustomerPhotos;

  constructor(
    private userService: UserService,
    private customerService: CustomerService,
    private photoAreaService: PhotoAreaService,
    private taskService: TaskService,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUserOrg()
      .then((res) => {
        this.isVme = res.organisationTypeId == 1;
      })
      .then(() => {
        if (this.isVme) {
          this.taskService.getStepTypes().then((res) => {
            this.stepTypesOpts = res.map((x) => ({ label: x.name, value: x.id }));
          });
          this.customerService.getPhotos(this.route.snapshot.params.id).then((res) => {
            this._customer = res;
            this._refreshPhotoAreas();
            this.selectedStepTypes = res.stepTypes;
          });
        } else {
          this.customerService.getPhotos().then((res) => {
            this._customer = res;
            this._refreshPhotoAreas();
          });
        }
      });

    this.photoAreaService.getAll().then((res) => {
      this.photoAreas = res.map((x) => ({
        ...x,
        ...{ isRequired: x.area == PhotoArea.Additional ? false : x.isMandatory },
      }));
      this._refreshPhotoAreas();
    });
  }

  submit() {
    if (this.isVme) {
      this._customer.stepTypes = this.selectedStepTypes;
    }
    this._customer.requiredPhotoAreas = this.photoAreas
      .filter((x) => !x.isMandatory && x.isRequired)
      .map((x) => x.area);

    this.customerService.savePhotos(this._customer);
  }

  cancel() {
    this.location.back();
  }

  getAreaName(area: PhotoArea) {
    return this.photoAreas.find((x) => x.area == area).description;
  }

  private _refreshPhotoAreas() {
    if (!this.photoAreas || !this.photoAreas.length) return;
    if (!this._customer) return;

    for (let item of this.photoAreas.filter((x) => x.area != PhotoArea.Additional)) {
      item.isRequired =
        item.isMandatory || this._customer.requiredPhotoAreas.indexOf(item.area) !== -1;
    }
  }
}
